import ProductConfigurationService from '@/core/services/product-configuration.service.js'

const DEFAULT_CODE = 'general'
const ALIASES = {
  maternal_child: 'maternal-child',
  kia: 'maternal-child',
  physiotherapy_rehab: 'physiotherapy',
}

const SKINS = {
  general: {
    code: 'general', name: 'Klinik Umum', eyebrow: 'Pusat operasional klinik',
    description: 'Tampilan netral untuk pelayanan primer sehari-hari.', icon: 'fas fa-clinic-medical',
    illustration: '/media/vertical-skins/general.png',
    palette: ['#1676A3', '#8B5CF6'],
  },
  dental: {
    code: 'dental', name: 'Klinik Gigi', eyebrow: 'Dental care workspace',
    description: 'Nuansa bersih dan presisi untuk alur perawatan gigi.', icon: 'fas fa-tooth',
    illustration: '/media/vertical-skins/dental.png',
    palette: ['#17759C', '#43B9B2'],
  },
  aesthetic: {
    code: 'aesthetic', name: 'Klinik Estetika', eyebrow: 'Aesthetic care studio',
    description: 'Nuansa hangat dan premium untuk perjalanan perawatan estetika.', icon: 'fas fa-spa',
    illustration: '/media/vertical-skins/aesthetic.png',
    palette: ['#9A527D', '#D98DA8'],
  },
  'maternal-child': {
    code: 'maternal-child', name: 'Klinik Ibu & Anak', eyebrow: 'Maternal & child care',
    description: 'Tampilan lembut untuk memantau kesehatan ibu dan tumbuh kembang anak.', icon: 'fas fa-baby',
    illustration: '/media/vertical-skins/maternal-child.png',
    palette: ['#8063A5', '#E08B9D'],
  },
  physiotherapy: {
    code: 'physiotherapy', name: 'Fisioterapi & Rehab', eyebrow: 'Recovery journey',
    description: 'Nuansa aktif untuk asesmen, program terapi, dan progres pemulihan.', icon: 'fas fa-running',
    illustration: '/media/vertical-skins/physiotherapy.png',
    palette: ['#237C78', '#F1A65A'],
  },
  mcu: {
    code: 'mcu', name: 'Medical Check Up', eyebrow: 'Preventive health command',
    description: 'Tampilan terstruktur untuk pemeriksaan, hasil, dan kesimpulan kesehatan.', icon: 'fas fa-heartbeat',
    illustration: '/media/vertical-skins/mcu.png',
    palette: ['#256A8D', '#E76D72'],
  },
  occupational: {
    code: 'occupational', name: 'Klinik Okupasi', eyebrow: 'Occupational health desk',
    description: 'Nuansa tegas untuk risiko kerja, surveillance, dan fitness to work.', icon: 'fas fa-hard-hat',
    illustration: '/media/vertical-skins/occupational.png',
    palette: ['#4B657C', '#D08A3B'],
  },
  eye: {
    code: 'eye', name: 'Klinik Mata', eyebrow: 'Vision care workspace',
    description: 'Nuansa fokus untuk pemeriksaan visual dan perjalanan layanan mata.', icon: 'fas fa-eye',
    illustration: '/media/vertical-skins/eye.png',
    palette: ['#446FA3', '#70AFA9'],
  },
  vaccination: {
    code: 'vaccination', name: 'Klinik Vaksinasi', eyebrow: 'Immunization center',
    description: 'Tampilan segar untuk jadwal, dosis, dan pemantauan imunisasi.', icon: 'fas fa-syringe',
    illustration: '/media/vertical-skins/vaccination.png',
    palette: ['#27868B', '#E0A737'],
  },
}

const normalize = code => {
  const normalized = String(code || DEFAULT_CODE).trim().toLowerCase()
  return ALIASES[normalized] || normalized.replace(/_/g, '-')
}

const resolveCode = configuration => {
  const verticals = (configuration && configuration.verticals) || []
  const activeCodes = verticals.map(item => normalize(item && item.code)).filter(code => SKINS[code])
  let branchCodes = []
  if (typeof window !== 'undefined' && window.localStorage.getItem('medhop_branch_id') !== 'all') {
    const branchSkin = normalize(window.localStorage.getItem('medhop_branch_vertical_skin'))
    if (SKINS[branchSkin]) return branchSkin
    try {
      branchCodes = JSON.parse(window.localStorage.getItem('medhop_branch_vertical_codes') || '[]')
        .map(normalize)
        .filter(code => SKINS[code])
    } catch (_) {
      branchCodes = []
    }
  }
  // A broad multi-service clinic is a general workspace, not whichever
  // specialist code happens to sort first in the entitlement response.
  if (branchCodes.length > 2) return DEFAULT_CODE
  const branchPreferred = branchCodes.find(code => code !== DEFAULT_CODE) || branchCodes[0]
  if (branchPreferred) return branchPreferred
  const preferred = normalize(configuration && configuration.experience && configuration.experience.primary_vertical)
  if (SKINS[preferred] && (activeCodes.length === 0 || activeCodes.includes(preferred))) return preferred
  return activeCodes.find(code => code !== DEFAULT_CODE) || DEFAULT_CODE
}

const VerticalSkinService = {
  resolve(configuration) {
    const code = resolveCode(configuration)
    return { ...SKINS[code], palette: [...SKINS[code].palette] }
  },
  current() {
    return this.resolve(ProductConfigurationService.current())
  },
  apply(configuration) {
    const skin = this.resolve(configuration || ProductConfigurationService.current())
    if (typeof document !== 'undefined') document.documentElement.setAttribute('data-medhop-skin', skin.code)
    if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent('medhop:vertical-skin', { detail: skin }))
    return skin
  },
}

export default VerticalSkinService
